import React, { useEffect, useState } from "react";

import {
    faUser
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Container,
    Dropdown,
    Form,
    Image,
    InputGroup,
    Nav,
    Navbar,
    NavDropdown
} from "react-bootstrap";
import { IoMdNotificationsOutline } from "react-icons/io";
import { IoSettingsOutline } from "react-icons/io5";
import { TbMessageDots } from "react-icons/tb";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutToken } from "../../helpers/utility";
import "../../assets/css/employer/EmployerNavbar.css";
import Swal from "sweetalert2";
import User from "../../assets/images/user.webp";
import { getEmployer } from "../../helpers/backendHelper";
import { IMAGE_HOST_URL } from "../../helpers/urlHelper";
import { PiSignOutBold } from "react-icons/pi";
import { FaRegUser } from "react-icons/fa";

const EmployerNavBar = () => {

    const { user } = useSelector(state => ({
        user: state.Login.user,
    }));

    const navigate = useNavigate();
    console.log("user", user);

    const [userData, setUserData] = useState({});

    // const [sidebarExpanded, setSidebarExpanded] = useState(false);

    // const toggleSidebar = () => {
    //     setSidebarExpanded(!sidebarExpanded);
    //     const wrapper = document.getElementById("wrapper");
    //     wrapper.classList.toggle("toggled");
    // };

    const handleLogout = async () => {
        const confirm = await Swal.fire({
            icon: "question",
            text: "Are you sure you want to logout?",
            showCancelButton: true,
            cancelButtonColor: '#d33',
            cancelButtonText: 'No',
            confirmButtonColor: '#3085d6',
            confirmButtonText: "Yes",
        });

        if (confirm.isConfirmed) {
            await logoutToken();
        }
    }

    const handleProfileClick = async () => {
        navigate(`/employer/employerProfile`);
    }

    const fetchData = async() => {
        const response = await getEmployer();
        setUserData(response.employer);
    }

    useEffect(()=>{
        const timerId = setTimeout(() => {
            fetchData();
        }, 500);
        return () => clearTimeout(timerId);
    },[]);

    return (
        <>
            <Navbar expand="lg" className="bg-transparent px-0 px-sm-2">
                <Container fluid className="d-flex justify-content-between">
                    {/* <Link
                    to="#"
                    className="text-decoration-none fw-bold text-dark icon-size-topbar"
                    onClick={toggleSidebar}
                >
                    <FontAwesomeIcon icon={faBars} id="sidebar" className="me-2 " />{" "}
                </Link> */}
                    <InputGroup className="input-search">
                        <Form.Control
                            type="text"
                            placeholder="Search here"
                            size="md"
                            className="py-2"
                        />
                        <InputGroup.Text className="cursor-pointer">
                            <i className="bi bi-search fs-4"></i>
                        </InputGroup.Text>
                    </InputGroup>

                    <Navbar.Toggle aria-controls="navbarScroll" className="navbar-toggle" />
                    <Navbar.Collapse id="navbarScroll">
                        <Nav
                            className="me-auto my-2 my-lg-0"
                            style={{ maxHeight: '100px' }}
                            navbarScroll
                        >
                        </Nav>

                        {/* <Nav.Link href="#action1" className="nav-link-icons border rounded me-3 my-1">
                        <IoMdNotificationsOutline className="fw-bolder" style={{color : "#2D9CDB"}} />
                    </Nav.Link>
                    <Nav.Link href="#action1" className="nav-link-icons border rounded me-3 my-1">
                        <TbMessageDots className="fw-bolder" style={{color : "#2D9CDB"}} />
                    </Nav.Link>
                    <Nav.Link href="#action1" className="nav-link-icons border rounded me-5 my-1">
                        <IoSettingsOutline className="fw-bolder" style={{color : "#2D9CDB"}} />
                    </Nav.Link> */}

                        <Nav navbarScroll>
                            <div className="d-flex align-items-center">
                                <p className="fs-5 mt-1 me-2">{userData?.name ? userData.name : ""}</p>
                                {/* <NavDropdown
                                    title={<FontAwesomeIcon className="nav-text fs-5" icon={faUser} />}
                                    align={{ md: "end" }}
                                    className="nav-text px-2 d-none d-lg-block"
                                >
                                    <NavDropdown.Item className="nav-text nav-background" onClick={handleProfileClick}>Profile</NavDropdown.Item>
                                    <NavDropdown.Item className="nav-text nav-background" onClick={handleLogout}>Logout</NavDropdown.Item>
                                </NavDropdown> */}

                                <Dropdown drop="down" className="nav-text d-none d-lg-block mb-1">
                                    <Dropdown.Toggle variant="none" id="dropdown-basic" className="p-0 dropdown-toggle" title="Profile">
                                        <Image 
                                            src={userData?.employerProfileImage === "null" ? User : `${IMAGE_HOST_URL}${userData?.employerProfileImage}`} 
                                            height="27" 
                                            className="rounded-pill" 
                                        />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu align="end">
                                        <Dropdown.Item className="nav-text nav-background d-flex justify-content-start align-items-center" onClick={handleProfileClick}>
                                            <FaRegUser />
                                            <span className="ms-2">Profile</span>
                                        </Dropdown.Item>
                                        <Dropdown.Item className="nav-text nav-background d-flex justify-content-start align-items-center" onClick={handleLogout}>
                                            <PiSignOutBold />
                                            <span className="ms-2">Logout</span>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            <div className="d-block d-lg-none">
                                <FontAwesomeIcon className="nav-text fs-5 me-2" icon={faUser} />
                                <p className="dropdown-font cursor-pointer" onClick={handleProfileClick}>Profile</p>
                            </div>
                            <div className="d-block d-lg-none">
                                <p className="dropdown-font cursor-pointer" onClick={handleLogout}>Logout</p>
                            </div>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>)
}

export default EmployerNavBar;